import { Link, useNavigate } from "react-router-dom";
import { Crown, LogOut, Menu, Plus, History, Gift } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useApp } from "@/context/AppContext";
import { BalanceDropdown } from "@/components/BalanceDropdown";

export function Header() {
  const { user, signOut, openStore } = useApp();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0B0E14]/80 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-3 h-16 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button data-testid="menu-btn" className="p-2 rounded-xl hover:bg-white/5 transition-colors"><Menu size={20} /></button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="bg-[#151A22] border-white/10 w-56">
              <div className="px-2 py-1.5 text-sm"><div className="font-bold">{user?.name}</div><div className="text-xs text-gray-400">{user?.vip?.tier} VIP</div></div>
              <DropdownMenuSeparator />
              <DropdownMenuItem data-testid="menu-vip" onClick={() => nav("/vip")}><Crown size={16} className="mr-2" />VIP Club</DropdownMenuItem>
              <DropdownMenuItem data-testid="menu-redeem" onClick={() => openStore("redeem")}><Gift size={16} className="mr-2" />Redeem</DropdownMenuItem>
              <DropdownMenuItem data-testid="menu-history" onClick={() => openStore("history")}><History size={16} className="mr-2" />Transaction History</DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem data-testid="menu-logout" onClick={() => { signOut(); nav("/login"); }}><LogOut size={16} className="mr-2" />Log out</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <BalanceDropdown />
        </div>
        <button
          data-testid="header-buy-btn"
          onClick={() => openStore("buy")}
          className="flex items-center gap-1 rounded-full bg-[#FFB800] text-[#0B0E14] font-display font-extrabold px-5 py-2 text-sm hover:brightness-110 active:scale-95 transition-[filter,transform] shadow-[0_0_20px_rgba(255,184,0,0.35)]"
        >
          <Plus size={16} strokeWidth={3} /> BUY
        </button>
      </div>
    </header>
  );
}
